import * as Constants from '../constants/action-constants';

import { all, call, put, takeLatest } from 'redux-saga/effects';
import {
  initializeSystemDetailsFailed,
  initializeSystemDetailsSuccess
} from '../actions/System';

import { SettingsApi } from 'vrlcm-gui-api';

function* getSystemDetails() {
  try {
    const systemDetails = yield call(SettingsApi.getSystemInformation);
    yield put(initializeSystemDetailsSuccess(systemDetails));
  } catch (error) {
    yield put(initializeSystemDetailsFailed());
  }
}

function* watchForSystemDetails() {
  yield takeLatest(Constants.INITIALIZE_SYSTEM_DETAILS, getSystemDetails);
}

export default function* systemSaga() {
  yield all([watchForSystemDetails()]);
}
